export default "__VITE_ASSET__CGDT2YvY__"